export enum WeightUnits {
  GRAMS = 'GRAMS'
}

export enum MemoryUnits {
  'BYTES_IN_MEGABYTE' = 1048576
}
